export enum EHeightDataType {
  HDT_NONE,
  HDT_TERRAIN,
  HDT_WATER,
  HDT_FOLIAGE,
}
